/**
 * StellariumViewer — embeds Stellarium Web Engine as an interactive sky view.
 *
 * Implementation note (Feb 2026):
 *   `stellarium-web-engine` is NOT published to npm. The official distribution
 *   is C++/Emscripten compiled to WASM, shipped by stellarium-labs. For this
 *   pass we embed the hosted stellarium-web viewer via iframe (CORS-clean,
 *   auth-free). Self-hosted WASM bundling is a Phase-D roadmap item.
 *
 *   Reference: https://stellarium-web.org  (official public instance)
 *              https://github.com/Stellarium/stellarium-web-engine
 */
import React from 'react';

const DEFAULT_VIEWER = 'https://stellarium-web.org';

export default function StellariumViewer({
  src = DEFAULT_VIEWER,
  height = 520,
  testId = 'stellarium-viewer',
  title = 'Stellarium sky view',
}) {
  return (
    <div
      data-testid={testId}
      style={{
        position: 'relative',
        width: '100%',
        height,
        borderRadius: 6,
        overflow: 'hidden',
        background: '#05070b',
        border: '1px solid rgba(100, 130, 180, 0.2)',
      }}
    >
      <iframe
        title={title}
        src={src}
        loading="lazy"
        referrerPolicy="no-referrer"
        sandbox="allow-scripts allow-same-origin allow-popups"
        style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
        data-testid={`${testId}-iframe`}
      />
      <div
        style={{
          position: 'absolute',
          bottom: 6,
          left: 8,
          fontSize: 10,
          letterSpacing: '0.12em',
          color: 'rgba(180, 200, 230, 0.55)',
          pointerEvents: 'none',
        }}
      >
        STELLARIUM · LIVE SKY
      </div>
    </div>
  );
}
